<template>
    <div>
        <div class="form-group mb-3">
            <div class="form-check">
                <input
                    type="checkbox"
                    class="form-check-input"
                    name="bring_own_badges"
                    id="bring_own_badges"
                    value="1"
                    :checked="checked"
                    @change="onChange"
                >
                <label class="form-check-label" for="bring_own_badges">
                    <slot name="label" />
                </label>
            </div>
        </div>

        <Modal ref="confirmModal" size="modal--mini">
            <div slot="content">
                <p><slot name="confirm-text">{{ confirmMessage }}</slot></p>
                <div>
                    <button type="button" class="btn-cta mr10" @click="confirm">
                        <slot name="confirm-label">OK</slot>
                    </button>
                    <button type="button" class="link" @click="cancel">
                        <slot name="cancel-label">Annuler</slot>
                    </button>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
import Modal from '../layout/Modal.vue';

export default {
    components: { Modal },
    props: {
        initialChecked: { type: Boolean, default: false },
        hasInitialItems: { type: Boolean, default: false },
        confirmMessage: { type: String, default: '' },
        sectionSelector: { type: String, default: '#badge-items-section' },
    },
    data() {
        return {
            checked: this.initialChecked,
        };
    },
    mounted() {
        this.syncVisibility();
    },
    methods: {
        onChange(event) {
            const requested = event.target.checked;
            if (requested && this.hasInitialItems) {
                // Revert visual state until user confirms; modal owns the decision.
                event.target.checked = false;
                this.openModal();
                return;
            }
            this.checked = requested;
            this.syncVisibility();
        },
        confirm() {
            this.checked = true;
            this.closeModal();
            this.syncVisibility();
        },
        cancel() {
            this.checked = false;
            this.closeModal();
            this.syncVisibility();
        },
        openModal() {
            // Mirror DeleteConfirmButton pattern: re-parent the modal under the root
            // Vue element so its fixed/absolute positioning escapes any local stacking
            // context (parent overflow, transforms, etc.).
            if (!this.$refs.confirmModal.isOpen) {
                this.$root.$el.appendChild(this.$refs.confirmModal.$el);
            }
            this.$refs.confirmModal.toggleModal();
        },
        closeModal() {
            if (this.$refs.confirmModal.isOpen) {
                this.$refs.confirmModal.toggleModal();
            }
        },
        syncVisibility() {
            const section = document.querySelector(this.sectionSelector);
            if (section) {
                section.style.display = this.checked ? 'none' : '';
            }
        },
    },
};
</script>
